// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"180":"7662bd0b","528":"f386ecb7"}[chunkId] + ".chunk.js";
};